<template>
  <div>
    <v-toolbar color="grey lighten-2" absolute flat height="24em" tabs>
      <template slot="extension">
        <v-tabs v-model="currentTab" centered flat icons-and-text class="pb-4" color="grey lighten-2">
           <v-tab href="#tab-1" to="/reportes-partido/info" v-if="$store.state.permissions.canViewReportes && $store.getters.isSafRole">
            <span>Datos de<br/>Partidos</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="top-spacing">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {

  data () {
    return {
      currentTab: null,
      tabs: [
        { id: 1, componentName: 'info' }
      ]
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
</style>
